import type { FC } from 'react';

import { useModulesContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-modules-context';

import { EntityInfoCompany } from './entity-info-company';
import { EntityInfoPublisherPage } from './entity-info-publisher-page';
import { EntityInfoTopicPage } from './entity-info-topic-page';

export const EntityInfoContainer: FC = () => {
  const { headerModule } = useModulesContext();

  const headerContent = headerModule?.content;

  if (headerContent?.__typename === 'EntityPageTopicPageHeaderContent') {
    return <EntityInfoTopicPage />;
  }
  if (headerContent?.__typename === 'EntityPageCompanyHeaderContent') {
    return <EntityInfoCompany />;
  }
  if (headerContent?.__typename === 'EntityPagePublisherHeaderContent') {
    return <EntityInfoPublisherPage />;
  }
  return null;
};
